// components/ui/Badge.jsx
import React from 'react';

export function Badge({ status }) {
  const variants = {
    pending_review: { bg: '#FEF3C7', color: '#92400E', label: 'Pending Review', pulse: true },
    under_review: { bg: '#FEF3C7', color: '#92400E', label: 'Under Review', pulse: true },
    verified: { bg: '#D1FAE5', color: '#065F46', label: 'Verified' },
    submitted: { bg: '#EFF6FF', color: '#1E40AF', label: 'Submitted' },
    processing: { bg: '#EFF6FF', color: '#1E40AF', label: 'Processing', pulse: true },
    shipped: { bg: '#F3E8FF', color: '#7C3AED', label: 'In Transit', pulse: true },
    delivered: { bg: '#D1FAE5', color: '#065F46', label: 'Delivered' },
    canceled: { bg: '#FEE2E2', color: '#991B1B', label: 'Canceled' },
    cancelled: { bg: '#FEE2E2', color: '#991B1B', label: 'Cancelled' },
    backordered: { bg: '#FEF3C7', color: '#92400E', label: 'Backordered', pulse: true },
    rejected: { bg: '#FEE2E2', color: '#991B1B', label: 'Rejected' },
    connected: { bg: '#D1FAE5', color: '#065F46', label: 'Connected' },
    error: { bg: '#FEE2E2', color: '#991B1B', label: 'Error' },
    syncing: { bg: '#EFF6FF', color: '#1E40AF', label: 'Syncing', pulse: true }
  };
  
  const variant = variants[status] || variants.submitted;
  
  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      padding: '4px 12px',
      borderRadius: 6,
      background: variant.bg,
      color: variant.color,
      fontSize: 12,
      fontWeight: 700,
      letterSpacing: '0.03em',
      textTransform: 'uppercase'
    }}>
      <span style={{
        width: 6,
        height: 6,
        borderRadius: '50%',
        background: variant.color,
        animation: variant.pulse ? 'pulse 2s infinite' : 'none'
      }} />
      {variant.label}
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>
    </span>
  );
}
